import React from "react";
import styled from "styled-components";

import imgIconSearch from "../../static/icons/table/loupe.svg";

const FormSearch = () => {
  return (
    <FormSearchWrapper>
      <img src={imgIconSearch} alt="up" />
      <input type="text" placeholder="Masukan kata kunci pencarian" />
    </FormSearchWrapper>
  )
}

const FormSearchWrapper = styled.div`
  display: flex;
  align-items: center;
  background: #fff;
  padding: 5px 10px 5px 10px;
  border: 1px solid var(--color-border);
  border-radius: var(--corner-radius-small);
  -webkit-appearance: none;

  & > img {
    width: 12px;
    height: 12px;
    margin-right: 10px;
  }

  & > input {
    border: none;
    width: 100%;
  }
`;

export default FormSearch;